<template>
  <div class="list-page-header">
    <h3 class="title">{{ this.$t("staff.list_page_title") }}</h3>

    <div class="primary-bulk-actions">
      <action-list-button
        v-if="$can(Staff.actions.add, Staff.subject)"
        :actions="bulkActions"
        :primaryBtnSettings="primaryAction"
      ></action-list-button>
    </div>
    <import-csv-modal
      :name="importModalName"
      title="staff.import_staffs_by_csv"
      :actions="importCSVModalActions"
      :validation-cols="validations"
    >
      <template #template-desc>
        <p class="template-desc">
          {{ $t("common.download") }}
          <a :href="templateLinks[0]" target="_blank">Basic CSV template</a>
          {{ $t("staff.or") }}
          <a :href="templateLinks[1]" target="_blank">Full CSV template</a>
          {{ $t("common.see_an_example_of_the_format_required") }}
        </p>
      </template>
    </import-csv-modal>
  </div>
</template>

<script>
import ActionListButton from "@/components/Base/ActionListButton";
import ImportCsvModal from "@/components/Base/ImportCsvModal";
import { validations } from "@/validations/staffs";
import { initLoader, Message } from "../../../helpers/utils";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import { service_paths } from "@/constants/Services";
import AWSConst from "@/constants/AWS";
import { Staff } from "@/constants/Permissions";
import { staff_router_names } from "../../../routes/routes";

const TEMPLATES_URL = process.env.VUE_APP_API_URL + service_paths.download;

export default {
  name: "ListPageHeader",
  components: { ActionListButton, ImportCsvModal },
  data() {
    return {
      Staff,
      importModalName: "import-staffs-csv-modal",
      primaryAction: {
        title: "common.add_new",
        onClick: () => {
          this.go2AddPage();
        }
      },
      bulkActions: [
        {
          content: "common.import_file",
          action: () => {
            this.$modal.show(this.importModalName);
          }
        }
      ],

      templateLinks: [
        `${TEMPLATES_URL}/csv-template/staff/basic`,
        `${TEMPLATES_URL}/csv-template/staff/full`
      ],

      importCSVModalActions: {
        primary: {
          title: "common.upload_and_continue",
          action: this.uploadFileToS3
        }
      },
      validations
    };
  },

  methods: {
    go2AddPage() {
      this.$router.push({ name: staff_router_names.addPage });
    },

    async uploadFileToS3(file) {
      let loader = initLoader();
      const s3FolderPath = AWSConst.S3_IMPORT_STAFF_PATH;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(savedLink, `${service_paths.import}/staffs`);
        this.$modal.hide(this.importModalName);
        Message.success(this.$t("staff.your_request_is_waiting_for_approval"));
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
